// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__3_OdH","slideImageWrapper":"Slide_slideImageWrapper__pGPT7","slideDown":"Slide_slideDown__3xJZO","slideUp":"Slide_slideUp__3DJK6"};